var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62267 14.1362C4.20286 14.1362 3.84513 13.9884 3.54947 13.6927C3.25382 13.3971 3.10599 13.0393 3.10599 12.6195V4.04453H2.34766V2.52786H5.90817V1.76953H10.0835V2.52786H13.652V4.04453H12.8937V12.6195C12.8937 13.0393 12.7459 13.3971 12.4502 13.6927C12.1545 13.9884 11.7968 14.1362 11.377 14.1362H4.62267ZM11.377 4.04453H4.62267V12.6195H11.377V4.04453ZM5.92811 11.33H7.35311V5.33005H5.92811V11.33ZM8.64657 11.33H10.0716V5.33005H8.64657V11.33Z",
    fill: "#EF183B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.97e2a2b535b408f72d23496f85c1ef1c.svg";
export { ForwardRef as ReactComponent };